module.exports = __webpack_public_path__ + "media/images/logo/acutezorg-a5b14b448d7e97c92fd0149b2253adf3.png";